import React, { useState } from "react";
import axios from "axios";
import "../../styles/loginPage/login.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Modal from "../modal/Modal";
import  confirmIcon from '../../assets/img/iconamoon--shield-yes-fill.svg';

const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [generalError, setGeneralError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const validateForm = () => {
    let isValid = true;
    setEmailError("");
    setGeneralError("");

    if (!email) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setEmailError("Please enter a valid email address");
      isValid = false;
    }

    return isValid;
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }
    setLoading(true);

    setTimeout(async () => {
      try {
        const res = await axios.post(`${baseUrl}/api/users/forgot-password`, { email });

        if (res.status === 200) {
            setIsModalVisible(true);
            setTimeout(() => {
            handleCloseModal();
          }, 5000);
        } 
      } catch (err) {
          setGeneralError('An error occurred. Please try again');
      } finally {
        setLoading(false);
      }
    }, 2000)
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    navigate("/login");
  };

  return (
    <>
      <div className="login-grid-container">
        <div className="second-grid-container">
          <div className="second-grid-column">
            {/* <div className="img-container">
              <img src={loginFrame} alt="illustration" />
            </div> */}
            <div className="welcome-message">Welcome to!</div>
            <div className="logo-name title">
              <span>MonitorPro</span>
            </div>
            <div className="description">
              Track your project's journey with precision and clarity. Monitor
              Pro empowers teams to achieve goals efficiently. Stay connected,
              informed, and in control.
            </div>
          </div>
          <div className="privacy-policy">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms & Conditions</a>
          </div>
        </div>
        <div className="first-grid-container">
          <div className="logo-name">
            <span>MonitorPro</span>
          </div>
          <div className="first-grid-column">
            {/* <div className="logo-name">MonitorPro</div> */}
            <div className="title">Forgot Password</div>

            <div className="login-form">
              <form onSubmit={handleForgotPassword}>
                <div className="form-group">
                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  {emailError && (
                    <div className="error-message">{emailError}</div>
                  )}
                </div>

                {generalError && (
                  <div className="error-message">{generalError}</div>
                )}
                <button
                  type="submit"
                  className={`login-btn ${loading ? "btn-disabled" : ""} `}
                  disabled={loading}
                >
                  {loading ? (
                    <AiOutlineLoading3Quarters className="loader" />
                  ) : (
                    "Submit"
                  )}
                </button>
              </form>

              <div className="back-office">
                <p>Looking For The Staff area?</p>
                <a href="/signup">Back Office</a>
              </div>
            </div>
          </div>
          <div className="copyright">
            © {new Date().getFullYear()} - AzulPlan. All rights reserved.
          </div>
        </div>

        {isModalVisible && (
          <Modal show={isModalVisible} onClose={handleCloseModal}>
            <div className="content confirmation">
              <div className="icon-container">
              <img src={confirmIcon} alt="confirm" width="57" height="57" style={{ color: '#007011' }} />
              </div>
              <div className="text">
                An email has been sent to your inbox with instructions to reset
                your password.
              </div>
              
            </div>
          </Modal>
        )}
      </div>
    </>
  );
};

export default ForgotPasswordForm;
